import { render, staticRenderFns } from "./InnerPlanking1.vue?vue&type=template&id=74da59da&"
import script from "./InnerPlanking1.vue?vue&type=script&lang=js&"
export * from "./InnerPlanking1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports